import { Component, output, viewChild } from '@angular/core';
import { UIIconComponent } from '@design-system';
import { BottomSheetComponent } from '../../../../components/bottom-sheet/bottom-sheet.component';
import { OrdersAction } from './orders-actions-bottom-sheet.model';

/**
 * Action menu opened from the three-dot button in the orders header.
 *
 * Emits the chosen action *after* it has closed itself, so the caller can open
 * the follow-up sheet without the two ever being open at the same time.
 */
@Component({
	selector: 'app-orders-actions-bottom-sheet',
	imports: [BottomSheetComponent, UIIconComponent],
	templateUrl: './orders-actions-bottom-sheet.component.html',
	host: {
		'data-cy': 'orders-actions-bottom-sheet'
	}
})
export class OrdersActionsBottomSheetComponent {
	readonly actionSelected = output<OrdersAction>();

	private readonly sheet = viewChild<BottomSheetComponent>('sheet');

	open(): Promise<void> {
		return this.sheet()?.open() ?? Promise.resolve();
	}

	close(): Promise<void> {
		return this.sheet()?.close() ?? Promise.resolve();
	}

	async onActionClick(action: OrdersAction): Promise<void> {
		await this.close();
		this.actionSelected.emit(action);
	}
}
